import qs from 'qs';
import ValidationError from "../../classes/ValidationError";
import Model from "../../classes/model/Model";
import User from "./User";
import Sms from "./Sms";
import Schedule from "./Schedule";
import Client from "./Client";

/**
 * @property {int} id
 * @property {int} old_id
 * @property {string} name
 * @property {string} phone
 * @property {int} schedule_id
 * @property {int} sms_id
 * @property {int} responsible_id
 * @property {int} client_id
 * @property {int} is_viewed
 * @property {int} pickup_date
 * @property {int} close_date
 * @property {int} status
 * @property {string} from
 * @property {string} roistat
 * @property {string} comment
 *
 * @property {int} created_by
 * @property {int} updated_by
 * @property {int} created_at
 * @property {int} updated_at
 *
 * @property {Schedule} schedule
 * @property {Sms} sms
 * @property {User} responsible
 * @property {User} creator
 * @property {User} updater
 */
export default class Bid extends Model {

    relations() {
        return {
            client: {class: Client, many: false},
            schedule: {class: Schedule, many: false},
            sms: {class: Sms, many: false},
            responsible: {class: User, many: false},
            creator: {class: User, many: false},
            updater: {class: User, many: false},
        };
    }

    static getList(filter = {}, page = 1, sort = undefined, perPage = 25,  extraFields = []) {

        return Bid.getAxios().get(Bid.getUrl('bid/list'), {
            params: {
                page: page,
                'per-page': perPage,
                filter: filter,
                sort: sort,
                expand: extraFields.length > 0 ? extraFields.join(',') : undefined,
            },
            paramsSerializer: params => qs.stringify(params),
        }).then((response) => {
            let data = [];
            for (let bid of response.data) {
                data.push(new Bid(bid));
            }
            return {data, headers: response.headers};
        });
    }

    static getById(id, extraFields = []) {

        return this.getAxios().get(this.getUrl('bid/get-by-id'), {
            params: {
                id: id,
                expand: extraFields.length > 0 ? extraFields.join(',') : undefined,
            },
        }).then(({data}) => {
            return new Bid(data);
        });
    }

    create() {
        return Bid.getAxios().post(this.getUrl('bid/create'), this.getValues()).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            this.id = data.id;
            return true;
        });
    }

    update() {
        if (!this.id) {
            throw new Error('id not set');
        }

        return Bid.getAxios().post(this.getUrl('bid/update'), this.getValues()).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return true;
        })
    }

    close() {
        if (!this.id) {
            throw new Error('id not set');
        }
        return Bid.getAxios().post(this.getUrl('bid/close'), {id: this.id}).then(({data}) => {
            if (data.success === false) {
                throw new Error(data.errors);
            }
            this.status = Bid.STATUS_ACTIVE;
            this.close_date = data.close_date;
            return true;
        });
    }

    archive(){
        if (!this.id) {
            throw new Error('id not set');
        }
        return Bid.getAxios().post(this.getUrl('bid/arhive'), {id: this.id}).then(({data}) => {
            if (data.success === false) {
                throw new Error(data.errors);
            }
            this.status = Bid.STATUS_DISABLED;
            this.close_date = data.close_date;
            return true;
        });
    }

    view() {
        if (!this.id) {
            throw new Error('id not set');
        }
        return Bid.getAxios().post(this.getUrl('bid/view'), {id: this.id}).then(({data}) => {
            if (data.success === false) {
                throw new Error(data.errors);
            }
            this.is_viewed = 1;
            this.pickup_date = data.pickup_date;
            this.responsible_id = data.responsible_id;
            return true;
        });
    }


    static getNoVisibleCount() {
        return Bid.getAxios().get(Bid.getUrl('bid/get-no-visible-count'), {
            params: {},
            paramsSerializer: params => qs.stringify(params),
        }).then((response) => {
            return response.data;
        });
    }
}
